import { render, staticRenderFns } from "./ActionRechazarPreIngreso.vue?vue&type=template&id=5c5a491a&scoped=true&lang=pug"
import script from "./ActionRechazarPreIngreso.vue?vue&type=script&lang=js"
export * from "./ActionRechazarPreIngreso.vue?vue&type=script&lang=js"
import style0 from "./ActionRechazarPreIngreso.vue?vue&type=style&index=0&id=5c5a491a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5a491a",
  null
  
)

export default component.exports